import * as api from '../../api/api-consulta-360';
import { 
    GET_EXCEL,
    CLEAN_CASOS,
    SET_QUERY_STATE
} from '../types';


export const obtenerExcel = (query) => ({
    type: GET_EXCEL,
    payload: api.getExcel(query)
});
export const limpiarCasos = () => ({
    type: CLEAN_CASOS,
  
});
export const setQueryState = (data) => ({
    type: SET_QUERY_STATE,
    payload:data
  
});


